export const getUniqueCitationDocumentIds = (citations: { documentId: string | null }[]): string[] => {
  const documentIds = new Set<string>();

  for (const citation of citations) {
    if (citation.documentId) {
      documentIds.add(citation.documentId);
    }
  }

  return Array.from(documentIds);
};
